module.exports = "<div class=\"userContBottom\">\r\n  <div class=\"userContent\">\r\n      <div>\r\n        <table id=\"actionLog\" lay-filter=\"actionLog\"></table>\r\n      </div>\r\n  </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/component/actionLog/actionLog.html
// module id = 207
// module chunks = 0